var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createPaginationContainer as relayCreatePaginationContainer, } from 'react-relay';
import useLoadMore from './hooks';
function withIsLoading(WrappedComponent) {
    return function (_a) {
        var relay = _a.relay, rest = __rest(_a, ["relay"]);
        var _b = useLoadMore(relay.loadMore), isLoading = _b.isLoading, loadMore = _b.loadMore;
        return (_jsx(WrappedComponent, __assign({}, rest, { relay: __assign(__assign({}, relay), { isLoading: function () { return isLoading; }, loadMore: loadMore }) }), void 0));
    };
}
function createPaginationContainer(Component, fragmentSpec, connectionConfig) {
    return relayCreatePaginationContainer(withIsLoading(Component), fragmentSpec, connectionConfig);
}
export default createPaginationContainer;
//# sourceMappingURL=index.js.map